import { FC } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../../store";
import App from "../app/App";
import LoadingIndicator from "../common/loading-indicator";

/**
 * Wrapper that requires authentication.
 * Redirects to /login?returnTo=<path> if not authenticated.
 * Renders the DashboardLayout (App) if authenticated.
 */
const AuthRequiredLayout: FC = () => {
  const { isAuthenticated, loading } = useSelector((state: RootState) => state.session);
  const location = useLocation();

  if (loading) return <LoadingIndicator />;

  if (!isAuthenticated) {
    return <Navigate to={`/login?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return <App />;
};

export default AuthRequiredLayout;
